import { render } from "./UploadComponentFerramentaUsuario.vue?vue&type=template&id=a7a7c884&scoped=true"
import script from "./UploadComponentFerramentaUsuario.vue?vue&type=script&lang=js"
export * from "./UploadComponentFerramentaUsuario.vue?vue&type=script&lang=js"

import "./UploadComponentFerramentaUsuario.vue?vue&type=style&index=0&id=a7a7c884&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7a7c884"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QCardSection,QIcon});
